<template>
  <div class="base_card border border-secondary" :class="classes">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ["classes"],
};
</script>

<style lang="scss">
.base_card {
  // position: relative;
  padding: 15px;
  // background: white;
  background: #f5f5fa;
  border-radius: 10px;
  margin-bottom: 20px;
  // background-image: url('@/assets/media/images/logo/logo.png');
  // background-repeat: no-repeat;
  // background-size: 50px 50px;
  // background-position: bottom left;

}
</style>
